import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Splits a free-text field into individual list items for display, for the
// common case where someone pasted a multi-item list into a single-item
// text input (job responsibility, authorized-activity, or additional-charge
// fields are all plain "one value" inputs, so a pasted list lands as one
// blob instead of several records). Prefers explicit newlines, falls back
// to " - " used as an inline bullet separator, then falls back to splitting
// on a full stop or semicolon (never on commas — commas are common WITHIN a
// single sentence/item, e.g. "Receive, verify, process and maintain samples"
// is one responsibility, not three). Returns a single-item array unchanged
// when the text doesn't look like a list, so it's safe to call on any short
// value without changing how it renders.
export function splitListItems(raw) {
  if (!raw || typeof raw !== "string") return [];
  const text = raw.trim();
  if (!text) return [];

  let parts = text.split(/\r?\n+/).map((s) => s.trim()).filter(Boolean);

  if (parts.length <= 1) {
    const dashSplit = text
      .replace(/\s+-\s+(?=[A-Z(])/g, "\n")
      .split("\n")
      .map((s) => s.trim())
      .filter(Boolean);
    if (dashSplit.length > 1) parts = dashSplit;
  }

  if (parts.length <= 1) {
    // Split only after a full stop or semicolon that is followed by
    // whitespace (avoids breaking on decimals like "0.5" or abbreviations).
    const sentenceSplit = text
      .split(/(?<=[.;])\s+/)
      .map((s) => s.trim())
      .filter(Boolean);
    if (sentenceSplit.length > 1) parts = sentenceSplit;
  }

  return parts.map((s) => s.replace(/^[-••\s]+/, "").trim()).filter(Boolean);
}
